import PortfolioModal from '../portfolio/modal';

export default function(data) {
  var self = this;
  self.projects = ko.observableArray([]);
  self.selectedProject = ko.observable();
  self.switchEdit = ko.observable(true);
  self.shareEmails = ko.observableArray([]);
  self.$rejectProjectModal = $('.js-reject-project-modal');
  self.threeSixtyPlayer = null;

  self.projectTitleWithDraftStatus = function(title,status){
    var titleStr = (status != 'draft') ? title : title + ' (draft)';
    return titleStr;
  };

  self.areEmailsValid = function(emails) {
    if (_.isEmpty(emails)) {
      return false;
    } else {
      return _.every(emails.split(','), function(email) {
        return (/^.+@.+\..+$/i).test(email);
      });
    }
  };

  self.view = function (proj, editMode) {
    if (editMode) {
      window.location = proj.edit_url();
    } else {
      self.showProjectView(proj.show_url(), {}, {commentCountChanged: (total_comments) => {
        proj.comment_count(total_comments);
      }});
    }
  };

  self.comment = function (proj) {
    if (!proj.commentable())
      return;

    self.showProjectView(proj.show_url(), {show_comments: true}, {commentCountChanged: (total_comments) => {
      proj.comment_count(total_comments);
    }});
  };

  self.makeRequest = _.memoize((url, loadingIndicator) => {
    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      loadingIndicator: loadingIndicator
    });
  });

  self.showProjectView = function(url, args = {}, events = {}) {
    const response = this.makeRequest(url, {container: null, positionTop: 'absolute'});
    response.done((response) => {
      new PortfolioModal('#js-project-gallery').show(response, args, events);
    });
  };

  self.initSortable = function() {
    $('#js-project-gallery').sortable({
      items: '.js-sortable',
      update: function (e, ui) {
        self.sortProjects();
      }
    }).sortable('enable');
  };

  self.disableSortable = function() {
    if ($('#js-project-gallery').hasClass('ui-sortable')) {
      $('#js-project-gallery').sortable('disable');
    }
  };

  self.sortProjects = function() {
    var data = {project: []};
    $('#js-project-gallery .js-sortable').each(function (idx, item) {
      var project = ko.dataFor(item);
      project.order(idx + 1);
      data['project'].push(project.id());
    });

    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.sort_portfolio_projects_path(),
      data: data
    });

  };

  self.savePrivacy = function(proj) {
    var data = {portfolio_project: {privacy_level: proj.privacy_level() }};
    var request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url: Kadenze.Routes.user_portfolio_project_path(proj.user_id(), proj.id()),
      data: data
    });

    request.done(function(response) {
      console.log('privacy saved');
    });

    request.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
      }
      new Kadenze.Notice.error({message: msg});
    });
  };

  self.showShareModal = function(item,event) {
    if (item.status() === 'draft')
      return;

    var params = {modal_title: 'Share Project', shareableObj: {id: item.id(), title: item.title(), description: item.description(), share_url: item.share_url(), user_id: item.user_id() }, emailShareCb: self.shareProject};
    var modal = new Kadenze.ShareModal(params);
    modal.show();
  };

  self.shareProject = function(item, emails) {
    // var request = new Kadenze.AjaxRequest({
    //   type: 'POST',
    //   url: Kadenze.Routes.share_user_portfolio_project_path(item.user_id, item.id),
    //   data: {emails: emails}
    // });

    // request.done(function(res) {
      new Kadenze.Notice.success("This feature is not available for now.");
    // });

    // request.fail(function(xhr, status, msg) {
    //   if (xhr.responseJSON) {
    //     msg = xhr.responseJSON.message;
    //   } else {
    //     msg = xhr.responseText;
    //   }
    //   new Kadenze.Notice.error({message: msg});
    // });
  };

  self.canAddProject = function() {
    if (Kadenze.isKannu || self.premiumMember || self.projects().length < self.maxFreeProjects)
      return true;
    else
      return false;
  };

  self.addNewProject = function() {
    if (self.canAddProject()){
      console.log('adding new project');
      self.$rejectProjectModal.modal('hide');
      window.location = self.add_new_project_url;
    }
    else{
      console.log('showing reject modal');
      self.$rejectProjectModal.modal('show');
    }
  };

  self.initUI = function() {
    Kadenze.Share.init();
  };

  self.startPortfolioDownload = function () {
    console.log('Starting porfolio download');
    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.user_portfolio_download_path(),
    });

    request.success(function(res) {
      new Kadenze.Notice.success({ message: 'Portfolio download started. You will receive an email once it\'s ready' });
    });

    request.fail(function(res) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
      }
      new Kadenze.Notice.error({message: msg});
    });
  };

  self.bindData = function(data) {

    var mapping = {
      'create': function(opts) {
        var subMap = {
          'projects': {
            'update': function(_opts) {
              return ko.mapping.fromJS(_.extend(_opts.data, {
                'sharing': false
              }));
            }
          }
        };
        return ko.mapping.fromJS(opts.data, subMap);
      }
    };
    var mapped = ko.mapping.fromJS(data, mapping);
    self.projects(mapped.projects());
    self.premiumMember = data.premium_member;
    self.add_new_project_url = data.add_new_project_url;
    self.maxFreeProjects = data.max_free_projects;
    self.initUI();
  };

  const __construct = function(that) {
    self.bindData(data);

    if (Kadenze.Util.getParameterByName('edit') === 'true') {
      self.initSortable();
    }
  }(this);
}
